import { useCreateSubmission } from '@hooks/mutations/ledger/useSubmission';
import { MintRequest } from '@daml.js/utility-registry-v0/lib/Utility/Registry/V0/Holding/Mint';
import { SUC_REQ_MINT, ERR_REQ_MINT } from '../../../../utils/strings';

export const useRequestMint = () => {
  const { submit } = useCreateSubmission(MintRequest, SUC_REQ_MINT, ERR_REQ_MINT);
  return submit;
};
